import { render, staticRenderFns } from "./RFinancieros.vue?vue&type=template&id=6ff50072&scoped=true&"
var script = {}
import style0 from "./RFinancieros.vue?vue&type=style&index=0&id=6ff50072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff50072",
  null
  
)

export default component.exports